module.exports = __webpack_public_path__ + "static/img/ring.6f37f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ceremony/ring.png
// module id = Yhej
// module chunks = 1